import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-button',
  templateUrl: './lib-button.component.html',
  styleUrls: ['./lib-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibButtonComponent {
  @Input() buttonText: string;
  @Input() styleName: string;
  @Input() buttonType = 'button';
  @Input() isIconButton: boolean | 'edit' | 'download' = false;
  @Input() isButtonDisabled = false;
  @Input() bgColor?: string;
  @Input() textColor?: string;
  @Input() borderStyle?: string;
  @Input() buttonHeight?: string;
  @Input() width?: string;
  @Input() minWidth?: string;
  @Input() padding?: string;
  @Input() fontWeight: string;
  @Output() clickEvent = new EventEmitter();

  triggerClickEvent(event: any): void {
    this.clickEvent.emit(event);
  }
}
